var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FAA00D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6205 8.13994L9.29419 14.3331L9.05512 14.625L3.37894 8.20237L3.39694 8.19506L3.375 8.19169L5.58113 4.50337L5.58225 4.5045L5.58113 4.5H12.474L12.4729 4.50394L14.625 8.13938L14.6205 8.13994ZM7.2315 8.39813L6.01087 10.4648L9.02138 13.9028L12.0381 10.4366L10.8444 8.39194L7.2315 8.39813ZM5.66887 10.0744L6.65888 8.39869L4.20525 8.40262L5.66887 10.0744ZM11.1381 7.911L13.9247 7.9065L12.1753 4.977L9.42919 4.98262L11.1381 7.911ZM13.8218 8.38687L11.4182 8.39081L12.3817 10.0417L13.8218 8.38687ZM10.5643 7.91213L9.05062 5.31788L7.515 7.91663L10.5643 7.91213ZM5.83987 4.9905L4.09613 7.92281L6.94237 7.91775L8.67487 4.98488L5.83987 4.9905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXas);
export default __webpack_public_path__ + "static/media/xas.b130632fae64fff7e2925e3c28decc69.svg";
export { ForwardRef as ReactComponent };